import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import PlayerCardButton from "./PlayerCardButton/PlayerCardButton";

const SelectChangeStaff = ({sideSelected, homeStaff, awayStaff, skipCallback, initialEvent, setEventDetails, confirmCallback, eventDetails, updateStaffHandler}) => {
    let selectedStaff = sideSelected == 'home' ? homeStaff : awayStaff;
    return (
        <>
        {!eventDetails?.playerSelected && <div style={{
            padding: "10px 30px",
            display: "flex",
            alignItems: "flex-start",
          }}>
            <div
                style={{
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    border: "1px solid black",
                    height: 35,
                    width: 35,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 20,
              }}
            >
                <Icon name="su-user" />
            </div>
            <div 
                style={{
                width: "85%",
                display: "flex",
                alignItems: "flex-start",
                }}
            >
            <div
                style={{
                    display: "flex",
                    flexDirection: 'column',
                    width: "80%",
                    marginRight: 30,
                }}
            >
              <h3 style={{paddingTop: '0.5em'}}>Staff</h3>
              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridGap: "10px",
              }}>
                {selectedStaff.map((staff) => {
                    return <PlayerCardButton 
                    key={staff.id} 
                    setEventDetails={setEventDetails} 
                    eventDetails={eventDetails} 
                    confirmCallback={confirmCallback} 
                    player={staff} 
                    initialEvent={initialEvent}
                    isStaff={true}
                  />
                })}
                </div>
            </div>
            {skipCallback ? (
                <button
                  style={{
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: "transparent",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    setEventDetails((data) => ({
                      ...data,
                      playerSelected: false,
                    }));
                    skipCallback && skipCallback();
                  }}
                >
                  X
                  <span
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                      fontSize: "16px",
                      textDecoration: "underline",
                      marginLeft: 5,
                    }}
                  >
                    Überspringen
                  </span>
                </button>
              ) : null}
              </div>
        </div>}
        </>
    )
};

export default SelectChangeStaff;